// extracted by mini-css-extract-plugin
export var bodySections = "_bj-8";
export var gray = "_bj-7";
export var green = "_bj-4";
export var iconContainer = "_bj-9";
export var iconWidgetContainer = "_bj-1";
export var phoneIcon = "_bj-2";
export var red = "_bj-5";
export var statusDot = "_bj-3";
export var widgetContainer = "_bj-0";
export var yellow = "_bj-6";